<div class="ui-g impressum-container">
  <!-- [ngClass]="{'full-view': isLogin, 'menu-view': !isLogin}"> -->
  <div *ngIf="isLogin" class="header header-background" id="impressumPageHeader">
    <img alt="Logo" class="logo-image" src="assets/images/logo-upperleft.png" />
    <div class="logo-title">
      {{ 'app.service_portal' | translate }}
    </div>
  </div>
  <div class="impressum-body">
    <div [innerHTML]="'impressum.heading' | translate"></div>
    <div [innerHTML]="'impressum.content' | translate : { portal: portalUrl }"></div>
  </div>
</div>
